import { FiAlertTriangle } from 'react-icons/fi';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import Button from '@/components/Button/Button';

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let errorMessage: string;
  let errorDetails: string | undefined;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || 'Page not found';
    errorDetails = error.data?.message;
  } else if (error instanceof Error) {
    errorMessage = error.message;
    errorDetails = error.stack;
  } else {
    errorMessage = 'An unexpected error occurred';
  }

  /* TODO: uses temporary styles from old project, redesigned as site with color palette is designed */

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-2xl">
        <div className="rounded-3xl border border-red-400/30 bg-red-500/10 p-8 shadow-xl ring-1 ring-red-400/20">
          <div className="mb-6 flex items-center gap-3">
            <div className="rounded-full bg-red-500/20 p-3">
              <FiAlertTriangle className="h-8 w-8 text-red-300" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-red-50">Something went wrong</h1>
              <p className="text-sm text-red-200/80">The application encountered an unexpected error</p>
            </div>
          </div>

          <div className="mb-6 rounded-2xl border border-red-400/20 bg-red-950/30 p-4">
            <p className="mb-2 text-sm font-semibold text-red-100">Error message:</p>
            <p className="text-sm text-red-200">{errorMessage}</p>
          </div>

          {errorDetails && (
            <details className="mb-6">
              <summary className="mb-2 cursor-pointer text-sm text-red-200/80 hover:text-red-200">View technical details</summary>
              <pre className="max-h-60 overflow-auto rounded-xl border border-red-400/20 bg-black/40 p-4 font-mono text-xs text-red-100">
                {errorDetails}
              </pre>
            </details>
          )}

          <div className="flex flex-wrap gap-3">
            <Button text="Go back" variant="filled" color="secondary" onClick={() => navigate(-1)} />
            <Button text="Go home" variant="outlined" color="secondary" onClick={() => navigate('/')} />
            <Button text="Reload page" variant="text" color="secondary" onClick={() => window.location.reload()} />
          </div>
        </div>
      </div>
    </div>
  );
}
